<template>
  <div class="home-page">
    <header class="scroller-outer">
      <div class="scroller" :style="{'transform': 'translateX(' + (activeIndex * -100) + '%)'}">
        <div class="header-scene page-1">
          <div class="slogan-container container">
            <h1>从科赛到和鲸，品牌全新升级</h1>
            <h3>From Kesci to HeyWhale, we witness the evolution together</h3>
          </div>
        </div>
        <div class="header-scene page-2">
          <div class="slogan-container container">
            <h1>和鲸 = 数据科学协同创新平台</h1>
            <h3>Data science collaborative innovation platform</h3>
          </div>
        </div>
        <div class="header-scene page-3">
          <div class="slogan-container container">
            <h1>数据科学社区 + 数据科学工具</h1>
            <h3>Data science community & Data science platform</h3>
          </div>
        </div>
        <div class="header-scene page-4">
          <div class="slogan-container container">
            <h1>Heywhale.com 域名正式启用</h1>
            <h3>Welcome to HeyWhale.com, a whole new place for data science</h3>
          </div>
        </div>
      </div>
      <div class="arrow left-arrow" @click="scroll(-1)" v-show="activeIndex > 0"></div>
      <div class="arrow right-arrow" @click="scroll(1)" v-show="activeIndex < 3"></div>
    </header>
    <section>
      <div class="bg-block">
        <div class="segment-container container">
          <img src="../assets/whale-talk.png" />
          <div class="segment-container">
            <div class="segment-card">
              <img src ="../assets/heyWhale_index_icon01.png">
              <h4>数据化及AI转型<br/>解决方案提供者</h4>
            </div>
            <div class="segment-card">
              <img src ="../assets/heyWhale_index_icon02.png">
              <h4>独立第三方<br/>数据科学社区</h4>
            </div>
            <div class="segment-card">
              <img src ="../assets/heyWhale_index_icon03.png">
              <h4>数据分析及<br/>AI开发协作工具</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-block bg-service">
        <div class="service-container container">
          <div class="block-header">
            <h2>和鲸是您的数据化及AI转型合作伙伴</h2>
            <h3>HeyWhale helps accelerate business growth and outcome with big data & AI</h3>
          </div>
          <div class="service-card-wrapper">
            <div class="service-card">
              <img src="../assets/icon-consult.svg" />
              <div class="service-info">
                <h2>咨询服务</h2>
                <p>为企业及政府提供<br/>数据化及AI转型咨询</p>
              </div>
            </div>
            <div class="service-card">
              <img src="../assets/icon-crowdsourcing.svg" />
              <div class="service-info">
                <h2>算法众包</h2>
                <p>为企业提供算法创新众包服务<br/>解决开放式问题</p>
              </div>
            </div>
            <div class="service-card">
              <img src="../assets/icon-recruit.svg" />
              <div class="service-info">
                <h2>人才对接与招募</h2>
                <p>建立企业与数据人才的对接通道<br/>人才招募精准高效</p>
              </div>
            </div>
            <div class="service-card">
              <img src="../assets/icon-addition.svg" />
              <div class="service-info">
                <h2>配套服务</h2>
                <p>为政府、园区、企业提供<br/>AI招商配套服务</p>
              </div>
            </div>
            <div class="service-card">
              <img src="../assets/icon-competition.svg" />
              <div class="service-info">
                <h2>数据竞赛</h2>
                <p>提供企业内外部数据竞赛<br/>一体化解决方案</p>
              </div>
            </div>
            <div class="service-card">
              <img src="../assets/icon-brand.svg" />
              <div class="service-info">
                <h2>科技/雇主品牌塑造</h2>
                <p>在数据智能时代<br/>建立有吸引力的雇主/科技品牌形象</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-block bg-community">
        <div class="community-container container">
          <div class="block-header">
            <img src="../assets/kesci-logo.svg"/>
            <h2>高质量的独立第三方数据科学社区</h2>
            <h3>High quality third-party community for data science enthusiasts</h3>
          </div>
          <div class="community-card-wrapper">
            <div class="community-card" id="community-card1">
              <span class="iconfont icon-touzi"></span>
              <h2>高质量的<br/>数据人才聚集</h2>
              <div class="card-meta-data">
                <h2>70%</h2>
                <p>的用户为<br/>硕士以上学历</p>
              </div>
              <div class="card-meta-data">
                <h2>50%</h2>
                <p>的用户毕业于985/211<br/>及海外重点高校</p>
              </div>
              <div class="card-meta-data">
                <h2>50%</h2>
                <p>的用户为行业顶尖<br/>企业在职数据人才</p>
              </div>
            </div>
            <div class="community-card" id="community-card2">
              <span class="iconfont icon-shujukexue"></span>
              <h2>高质量的<br/>算法内容沉淀</h2>
              <div class="card-meta-data">
                <h2>1500+</h2>
                <p>主流算法模块</p>
              </div>
              <div class="card-meta-data">
                <h2>100+</h2>
                <p>顶尖企业数据实操案例</p>
              </div>
              <div class="card-meta-data">
                <h2>6000+</h2>
                <p>数据算法应用案例</p>
              </div>
            </div>
            <div class="community-card" id="community-card3">
              <span class="iconfont icon-hejing_shujuji"></span>
              <h2>高质量的<br/>真实数据集</h2>
              <div class="card-meta-data">
                <h2>5000G+</h2>
                <p>优质数据集资源</p>
              </div>
              <div class="card-meta-data">
                <h2>50+</h2>
                <p>企业开放数据</p>
              </div>
              <div class="card-meta-data">
                <h2>30+</h2>
                <p>科研机构独家发布</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-block bg-platform">
        <div class="platform-container container">
          <div class="block-header">
            <img src="../assets/klab-logo.svg"/>
            <h2>高效率的数据分析及AI开发平台</h2>
            <h3>High efficiency scalable data science platform</h3>
          </div>
          <div class="platform-card-wrapper">
            <div class="platform-card">
              <h2>教育版</h2>
              <h3>数据科学与人工智能<br/>高校教研平台</h3>
            </div>
            <div class="platform-card">
              <h2>科研版</h2>
              <h3>科研机构<br/>数据科学研发平台</h3>
            </div>
            <div class="platform-card">
              <h2>企业版</h2>
              <h3>企业数据分析及AI<br/>开发平台</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-block bg-client">
        <div class="client-container container">
          <div class="block-header">
            <h2>我们的客户</h2>
            <h3>Our Clients</h3>
          </div>
          <div class="client-content">
            <p>2015年成立至今，我们服务了众多顶尖客户</p>
            <div class="client-img-container">
              <div class="client-logo-card" v-for="(item, index) in partners" :key="index" @click="$router.push({name: 'case', params: {id: item.logo}})">
                <img class="normal-logo" :src="'https://cdn.kesci.com/client/logo/v2/' + item.logo + '.png'">
                <img class="grey-logo" :src="'https://cdn.kesci.com/client/logo/v2/' + item.logo + '_grey.png'">
              </div>
            </div>
            <!-- <img src="../assets/img-client.svg"/> -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import partners from '../data/partners.json';
export default {
  data() {
    return {
      partners: partners,
      timer: null,
      activeIndex: 0
    };
  },
  beforeRouteEnter(from, to, next) {
    next((vm) => {
      vm.setupTimer();
    });
  },
  beforeRouteLeave(from, to, next) {
    this.clearTimer();
    next();
  },
  methods: {
    setupTimer() {
      this.timer = window.setTimeout(() => {
        this.scroll(1, true);
        this.setupTimer();
      }, 6000);
    },
    clearTimer() {
      if (this.timer) {
        window.clearTimeout(this.timer);
      }
    },
    scroll(direction, auto) {
      if (!auto) {
        this.clearTimer();
        this.setupTimer();
      }
      let t = this.activeIndex + direction;
      if (t >= 4) {
        t = 0;
      }
      if (t < 0) {
        t = 3;
      }
      this.activeIndex = t;
    }
  }
};
</script>

<style lang="scss">
.home-page {
  .bg-service {
    h2, h3 {
      color: #fff;
    }
    background-image: url('../assets/bg-service.jpg');
    background-size: cover;
    background-position: center center;
    margin-bottom: 24px;
  }
  .bg-community {
    margin-bottom: 24px;
  }
  .bg-platform {
    h2, h3 {
      color: #fff;
    }
    background-image: url('../assets/bg-platform.png');
    background-size: cover;
    background-position: center center;
    height: 800px;
    margin-bottom: 120px;
  }
  .bg-client {
    background-color: #fff;
    margin-bottom: 60px;
  }
  .scroller-outer {
    width: 100%;
    overflow-x: hidden;
    position: relative;
    height: 35vw;
    min-height: 450px;
    .arrow {
      cursor: pointer;
      padding: 100px 24px;
      position: absolute;
      top: 33%;
      background-image: url("..//assets/banners/arrow.png");
      background-size: 20px;
      background-position: center center;
      background-repeat: no-repeat;
      &.left-arrow {
        left: 16px;
        transform: rotate(180deg);
      }
      &.right-arrow {
        right: 16px;
      }
    }
  }
  .scroller {
    height: 100%;
    transition: transform ease 1s;
    display: flex;
  }
  .header-scene {
    height: 100%;
    width: 100%;
    flex-grow: 0;
    flex-shrink: 0;
    background-size: cover;
    background-position: center center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    &.page-1 {
      background-image: url('../assets/banners/index-1.jpg');
    }
    &.page-2 {
      background-image: url('../assets/banners/index-2.png');
    }
    &.page-3 {
      background-image: url('../assets/banners/index-3.png');
    }
    &.page-4 {
      background-image: url('../assets/banners/index-4.png');
    }
    .slogan-container {
      color: #fff;
    }
  }
  .block-header {
    img {
      height: 40px;
      width: auto;
    }
  }
  .segment-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      width: auto;
      height: 180px;
    }
  }
  .segment-card {
    display: flex;
    margin-left: 52px;
    min-width: 240px;
    img {
      height: 88px;
      margin-right: 18px;
    }
  }
  .service-card-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .service-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 6px;
    width: 31%;
    padding: 24px 30px;
    margin: 25px 0px;
    height: 250px;
    background-image: linear-gradient(to top right, #006EFF, #0070FF 50%, #00A8FF);
    h2 {
      font-size: 24px;
      font-weight: 500;
    }
    p {
      color: #fff;
      line-height: 1.5;
    }
    img {
      height: 94px;
      width: auto;
      align-self: flex-end;
    }
    .service-info {
      align-self: flex-start;
    }
  }
  .community-card-wrapper {
    #community-card1 {
      background-image: url('../assets/bg-community-card1.png');
    }
    #community-card2 {
      background-image: url('../assets/bg-community-card2.png');
    }
    #community-card3 {
      background-image: url('../assets/bg-community-card3.png');
    }
    .community-card {
      color: #fff;
      background-size: cover;
      background-repeat: no-repeat;
      height: 160px;
      margin: 16px 0px;
      padding: 16px 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      h2 {
        width: 20%;
        font-size: 24px;
        font-weight: 500;
      }
      p {
        color: #fff;
        font-size: 16px;
        line-height: 1.5;
      }
      .iconfont {
        font-size: 56px;
      }
      .card-meta-data {
        width: 20%;
      }
    }
  }
  .platform-card-wrapper {
    position: relative;
    top: 500px;
    background-color:#FFFFFF;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    width: 1080px;
    height: 150px;
    border-radius: 4px;
    box-shadow: 0px 0px 23px 0px rgba(23, 128, 224, 0.12);
    h2 {
      font-size: 24px;
      color: #006EFF;
      margin-bottom: 16px;
    }
    h3 {
      font-size: 16px;
      line-height: 1.2;
      color: #636363;
    }
    .platform-card {
      width: 33%;
      padding: 12px;
      text-align: center;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 43px;
        width: 1px;
        height: 64px;
        background-color: #979797;
      }
      &:last-child::after {
        display: none;
      }
    }
  }
  .client-content {
    text-align: center;
    p {
      color: #9B9B9B;
      font-size: 16px;
    }
  }
  .client-img-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }
  .client-logo-card {
    margin: 12px 24px;
    cursor: pointer;
    position: relative;
    width: 100px;
    height: 32px;
    img {
      width: 100%;
      height: auto;
      transition: opacity ease 0.3s;
      position: absolute;
      left: 0;
      top: 0;
    }
    .normal-logo {
      opacity: 0;
    }
    .grey-logo {
      opacity: 1;
    }
    &:hover {
      .normal-logo {
        opacity: 1;
      }
      .grey-logo {
        opacity: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue